module.exports = __webpack_public_path__ + "img/add-employees.adab0b67.webp";